// src/components/CurrencyConverter.js

import React, { useState, useEffect } from 'react';
import CurrencyService from "../Modules/Setup/controller/CurrencyController/CurrencyController"
import { API_URL, API_KEY } from './CurrencyConfig';

const CurrencyConverter = ({ baseCurrency, targetCurrency, amount, currencyList, IsAuto }) => {
    const [convertedPrice, setConvertedPrice] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchConversionRate = async () => {
            setLoading(true);
            setError(null);
            const redirectCallback = () => { }; // Define a no-op redirect function if needed
            const baseCurrencyCode = await CurrencyService.CurrenyBySymbol(redirectCallback, baseCurrency);
            const targetCurrencyCode = await CurrencyService.CurrenyBySymbol(redirectCallback, targetCurrency);
            if (IsAuto === "1") {

                try {


                    const currencyCodes = currencyList.map(currency => currency.vc_CurrencyCode).join(',');
                    const apiUrl = `${API_URL}latest?apikey=${API_KEY}&currencies=${currencyCodes}&base_currency=${baseCurrencyCode[0].vc_CurrencyCode}`;

                    const response = await fetch(apiUrl);

                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    const responseData = await response.json();

                    if (responseData.data) {
                        const exchangeRates = responseData.data;
                        if (exchangeRates[targetCurrencyCode[0].vc_CurrencyCode]) {
                            const exchangeRate = exchangeRates[targetCurrencyCode[0].vc_CurrencyCode];
                            const converted = amount * exchangeRate;
                            setConvertedPrice(converted);
                        } else {
                            setError(`Exchange rate for ${targetCurrencyCode} not found.`);
                        }
                    } else {
                        setError('Invalid response data.');
                    }
                } catch (error) {
                    setError(`Error fetching currency data: ${error.message}`);
                } finally {
                    setLoading(false);
                }
            }
            else {
                let ConvertedManualPrice = targetCurrencyCode[0].dec_CurrencyToBaseRate;
                ConvertedManualPrice = ConvertedManualPrice * amount;
                setConvertedPrice(parseFloat(ConvertedManualPrice).toFixed(2));
                setLoading(false);
            }
        };

        if (baseCurrency && targetCurrency && amount != null) {
            fetchConversionRate();
        }
    }, [baseCurrency, targetCurrency, amount]);

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>Error: {error}</div>;
    }

    return (
        <span>
            {convertedPrice !== null ? (
                parseFloat(convertedPrice).toFixed(2)
            ) : (
                "0.00"
            )}
        </span>
    );
};

export default CurrencyConverter;

